export class Regla {
    public idcompania: string;
    public idRegla: string;
    public descripcion: string;
    public tipoRegla: string;
    public valorAlfanumerico: string;
    public valorNumerico: number;
    public valorLogico: boolean;
    public estado: string;
    public reglaInterna: string;
    public migrarDispositivo: string;
}